'use es6';

import { createSelector } from 'reselect';
import { CourseCategories } from '../constants/CourseConstants';
import { MarketingCategories, SalesCategories, ServiceCategories } from '../constants/TopFilterConstants';
import { getLessonSubcategories } from './lessonSelectors';
import { getTrackSubcategories } from './trackSelectors';

const getDisplaycategories = subCategories => {
  const displayCategories = [];

  if (MarketingCategories.intersect(subCategories).size) {
    displayCategories.push({
      label: CourseCategories.MARKETING
    });
  }

  if (SalesCategories.intersect(subCategories).size) {
    displayCategories.push({
      label: CourseCategories.SALES
    });
  }

  if (ServiceCategories.intersect(subCategories).size) {
    displayCategories.push({
      label: CourseCategories.SERVICE
    });
  }

  if (subCategories.includes(CourseCategories.WEB_DESIGN)) {
    displayCategories.push({
      label: CourseCategories.DESIGN
    });
  }

  return displayCategories;
};

export const getLessonDisplayCategories = createSelector(getLessonSubcategories, getDisplaycategories);
export const getTrackDisplayCategories = createSelector(getTrackSubcategories, getDisplaycategories);